import {StatusAvatar} from '@github-ui/status-avatar/StatusAvatar'
import {DotFillIcon} from '@primer/octicons-react'
import type {SxProp} from '@primer/styled-react'

import type {ViewerData} from '../../commit-conversations/types'
import styles from './InProgressCommentIndicator.module.css'

export function InProgressCommentIndicator({
  authorAvatarUrl,
  authorLogin,
  lineSpacingPreference,
  sx,
}: {
  authorAvatarUrl: string
  authorLogin: string
  lineSpacingPreference: ViewerData['lineSpacingPreference']
  sx?: SxProp['sx']
}) {
  const size = lineSpacingPreference === 'compact' ? 18 : 20

  return (
    <StatusAvatar
      altText={`${authorLogin}'s avatar image with pending indicator`}
      icon={DotFillIcon}
      iconColor="var(--fgColor-attention, var(--color-attention-fg))"
      square={false}
      size={size}
      src={authorAvatarUrl}
      sx={{
        ...sx,
      }}
      backgroundClassName={styles.InProgressCommentIndicatorBackground}
      className={styles.InProgressCommentIndicatorContainer}
    />
  )
}
